import { render, staticRenderFns } from "./FeedBackList.vue?vue&type=template&id=58de5f4a"
import script from "./FeedBackList.vue?vue&type=script&lang=js"
export * from "./FeedBackList.vue?vue&type=script&lang=js"
import style0 from "./FeedBackList.vue?vue&type=style&index=0&id=58de5f4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports